var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[
    'icon-button',
    {
      'icon-button--is-column': _vm.isColumn,
      'icon-button--is-disabled': _vm.disabled,
    } ],on:{"click":function($event){return _vm.$emit('action')}}},[_c(_vm.getIcon(_vm.icon),{tag:"component",class:['icon-button__svg', { 'icon-button__svg-is-column': _vm.isColumn }]}),_c('span',{staticClass:"icon-button__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }